import './setari.css';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft, faTrash, faCheck, faEye, faEyeSlash, faCrown, faCalendarAlt, faCalendarCheck, faCalendar, faCreditCard, faFileInvoice, faCog} from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import Logo from '../header/images/logo.png';



const apiUrl = process.env.REACT_APP_API_URL;

const Setari = () => {

   const navigate = useNavigate();

  const [activeMenu, setActiveMenu] = useState('personalInfo');
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  const [successMessage, setSuccessMessage] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [darkMode, setDarkMode] = useState(false); // va fi setat din userData
  const [soundEffects, setSoundEffects] = useState(() => {
    const saved = localStorage.getItem('soundEffects');
    return saved !== 'false'; // Default true
  });

  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [passwordSuccess, setPasswordSuccess] = useState('');
  const [hasPassword, setHasPassword] = useState(true); // verifică dacă are parolă setată


   const redirectToDashbord = useNavigate()
  const [showInfoPersMob, setShowInfoPersMob] = useState('-9');
  const funcShowInfoPersMob = () => {
        setShowInfoPersMob('-9');
    }

    const funcShowChangePass = () => {
        setShowInfoPersMob('-9');
    }

    const funcShowPlanDetailed = () => {
        setShowInfoPersMob('-9');
    }

    const funcShowCloseAccount = () => {
        setShowInfoPersMob('-9');
    }


    const [pageDashbord, setPageDashbord] = useState(true);


    // Funcția pentru a prelua datele utilizatorului
  const fetchUserData = async () => {
    try {
      const response = await fetch(`${apiUrl}/user`, {
        method: 'GET',
        credentials: 'include',
      });

      if (response.ok) {
        const data = await response.json();
        setUserData(data);
        setHasPassword(data.has_password !== false);
        if (typeof data.dark_mode === 'boolean') {
          setDarkMode(data.dark_mode);
        }
      } else {
        // Setăm date default pentru utilizatori neautentificați
        setUserData({
          username: 'Vizitator',
          email: '',
          profile_picture: '',
          account_type: 'free',
          is_active: false
        });
      }
    } catch (err) {
      console.error('Eroare la preluarea datelor utilizatorului:', err);
      // Setăm date default și la eroare
      setUserData({
        username: 'Vizitator',
        email: '',
        profile_picture: '',
        account_type: 'free',
        is_active: false
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  // Effect pentru aplicarea dark mode
  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add('dark-mode');
    } else {
      document.documentElement.classList.remove('dark-mode');
    }
  }, [darkMode]);

  // Handler pentru dark mode toggle
  const handleDarkModeToggle = async () => {
    const newDarkMode = !darkMode;
    setDarkMode(newDarkMode);
    try {
      await fetch(`${apiUrl}/user/preferences`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ dark_mode: newDarkMode })
      });
    } catch (err) {
      console.error('Eroare la salvarea preferintei dark mode:', err);
    }
  };

  // Handler pentru sound effects toggle
  const handleSoundEffectsToggle = () => {
    setSoundEffects(!soundEffects);
    localStorage.setItem('soundEffects', (!soundEffects).toString());
  };

  // Funcție pentru schimbarea parolei
  const handleChangePassword = async (e) => {
    e.preventDefault();
    setPasswordError('');
    setPasswordSuccess('');

    // Validări
    if (!currentPassword || !newPassword || !confirmPassword) {
      setPasswordError('Te rugăm să completezi toate câmpurile');
      return;
    }

    if (newPassword.length < 6) {
      setPasswordError('Parola nouă trebuie să aibă minim 6 caractere');
      return;
    }

    if (newPassword !== confirmPassword) {
      setPasswordError('Parolele noi nu coincid');
      return;
    }

    if (currentPassword === newPassword) {
      setPasswordError('Parola nouă trebuie să fie diferită de cea curentă');
      return;
    }

    try {
      const response = await fetch(`${apiUrl}/user/change-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          currentPassword,
          newPassword
        })
      });

      const result = await response.json();

      if (response.ok) {
        setPasswordSuccess('Parola a fost schimbată cu succes!');
        setCurrentPassword('');
        setNewPassword('');
        setConfirmPassword('');
        
        // Ascunde mesajul după 5 secunde
        setTimeout(() => setPasswordSuccess(''), 5000);
      } else {
        setPasswordError(result.message || 'Eroare la schimbarea parolei');
      }
    } catch (error) {
      console.error('Eroare la schimbarea parolei:', error);
      setPasswordError('A apărut o eroare. Te rugăm să încerci din nou.');
    }
  };

 // Funcție pentru a schimba imaginea de profil
 const handleFileChange = (event) => {
  const file = event.target.files[0];
  if (file) {
    setSelectedFile(file);
    setPreviewImage(URL.createObjectURL(file)); // Arată un preview
  }
};

// Funcție pentru a încărca imaginea pe server
const uploadProfilePicture = async () => {
  if (!selectedFile) {
    alert('Te rog să selectezi un fișier.');
    return;
  }

  const formData = new FormData();
  formData.append('profile_picture', selectedFile);

  try {
    const response = await fetch(`${apiUrl}/user/update-profile-picture`, {
      method: 'POST',
      credentials: 'include',
      body: formData,
    });

    const result = await response.json();

    if (response.ok) {
      setSuccessMessage('Imaginea a fost actualizată cu succes.');
      setUserData({ ...userData, profile_picture: result.profile_picture });
      setPreviewImage(null);
      setSelectedFile(null);
    } else {
      alert(result.message || 'Eroare la actualizarea imaginii.');
    }
  } catch (err) {
    console.error('Eroare la încărcarea imaginii:', err);
    alert('A apărut o eroare.');
  }
};


  // Funcție pentru a șterge imaginea de profil
  const handleDeleteProfilePicture = async () => {
    if (window.confirm('Ești sigur că dorești să ștergi imaginea de profil?')) {
      try {
        const response = await fetch(`${apiUrl}/user/delete-profile-picture`, {
          method: 'DELETE',
          credentials: 'include',
        });

        if (response.ok) {
          alert('Imaginea de profil a fost ștearsă.');
          fetchUserData();
        }
      } catch (err) {
        console.error('Eroare la ștergerea imaginii:', err);
      }
    }
  };

  if (loading) return <div>Se încarcă datele...</div>;
  // if (!userData || userData.username === 'Vizitator') return <div>Trebuie sa fii autentificat pentru a accesa pagina de setari.</div>;


    const renderpageDashbord = () => {

        if (pageDashbord === 'changePass') {
                // Verifică dacă utilizatorul are cont social (fără parolă)
                if (!hasPassword) {
                    return (
                        <div className='container-mob-menu-width'>
                            <div className='sub-arrow-info' onClick={funcShowChangePass}>
                                <div className='arrow-submenu-user-items'><FontAwesomeIcon icon={faChevronLeft} className='size-arrow-mob-user' /></div>
                                <div className='button-exit-setari'>Gata</div>
                            </div>
                            <div className='width-submenu-elements'>
                                <h4 className='title-setari-info'>Schimbare parolă</h4>
                                <div className='social-account-notice'>
                                    <div className='notice-icon'>🔒</div>
                                    <div className='notice-content'>
                                        <h5>Cont social</h5>
                                        <p>
                                            Te-ai autentificat cu Google sau LinkedIn. 
                                            Conturile sociale nu folosesc parolă, deci nu poți schimba parola aici.
                                        </p>
                                        <p style={{ marginTop: '12px', fontSize: '13px', color: '#7f8c8d' }}>
                                            💡 Dacă dorești să adaugi o parolă pentru autentificare clasică, 
                                            te rugăm să ne contactezi.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                }

                return (
                <div className='container-mob-menu-width'>
                     <div className='sub-arrow-info' onClick={funcShowChangePass}>
                        <div className='arrow-submenu-user-items'><FontAwesomeIcon icon={faChevronLeft} className='size-arrow-mob-user' /></div>
                        <div className='button-exit-setari'>Gata</div>
                    </div>
                    
                    <form className='width-submenu-elements' onSubmit={handleChangePassword}>
                       <h4 className='title-setari-info'>Schimbare parola</h4>
                       
                       {/* Mesaje de eroare/succes */}
                       {passwordError && (
                           <div className='alert-error'>
                               <FontAwesomeIcon icon={faCheck} style={{ marginRight: '8px' }} />
                               {passwordError}
                           </div>
                       )}
                       
                       {passwordSuccess && (
                           <div className='alert-success'>
                               <FontAwesomeIcon icon={faCheck} style={{ marginRight: '8px' }} />
                               {passwordSuccess}
                           </div>
                       )}
                       
                      <div className='form-group-modern'>
                          <label className='form-label-modern'>Parola curenta</label>
                          <div className='password-input-wrapper'>
                            <input
                              type={showCurrentPassword ? 'text' : 'password'}
                              className='form-input-modern'
                              placeholder='Introdu parola curenta'
                              value={currentPassword}
                              onChange={(e) => setCurrentPassword(e.target.value)}
                              required
                            />
                            <button 
                                type='button'
                                className='password-toggle-btn'
                                onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                            >
                                <FontAwesomeIcon icon={showCurrentPassword ? faEyeSlash : faEye} />
                            </button>
                          </div>
                      </div>

                      <div className='form-group-modern'>
                          <label className='form-label-modern'>Parola noua</label>
                          <div className='password-input-wrapper'>
                            <input
                              type={showNewPassword ? 'text' : 'password'}
                              className='form-input-modern'
                              placeholder='Introdu parola noua (minim 6 caractere)'
                              value={newPassword}
                              onChange={(e) => setNewPassword(e.target.value)}
                              required
                            />
                            <button 
                                type='button'
                                className='password-toggle-btn'
                                onClick={() => setShowNewPassword(!showNewPassword)}
                            >
                                <FontAwesomeIcon icon={showNewPassword ? faEyeSlash : faEye} />
                            </button>
                          </div>
                      </div>

                      <div className='form-group-modern'>
                          <label className='form-label-modern'>Confirma parola noua</label>
                          <div className='password-input-wrapper'>
                            <input
                              type={showNewPassword ? 'text' : 'password'}
                              className='form-input-modern'
                              placeholder='Introdu din nou parola noua'
                              value={confirmPassword}
                              onChange={(e) => setConfirmPassword(e.target.value)}
                              required
                            />
                          </div>
                      </div>

                      <button type='submit' className='btn-save-profile'>
                          <FontAwesomeIcon icon={faCheck} style={{ marginRight: '8px' }} />
                          Schimba parola
                      </button>
                    </form>
                </div>
            );
        }
            else if(pageDashbord === 'infoFact') {
                return (
                <div className='container-mob-menu-width'>
                    <div className='sub-arrow-info' onClick={funcShowPlanDetailed}>
                        <div className='arrow-submenu-user-items'><FontAwesomeIcon icon={faChevronLeft} className='size-arrow-mob-user' /></div>
                        <div className='button-exit-setari'>Gata</div>
                       
                    </div>
                    <div className='width-submenu-elements'>
                       <h4 className='title-setari-info'>Detalii plan</h4>
                       
                       {/* Card principal cu planul curent */}
                       <div className='plan-card-container'>
                         <div className='plan-card-header'>
                           <div className='plan-badge'>
                             <FontAwesomeIcon icon={faCrown} className='plan-icon' />
                             <span>PERSONAL</span>
                           </div>
                           <div className='plan-status active'>Activ</div>
                         </div>
                         
                         <div className='plan-details-grid'>
                           <div className='plan-detail-item'>
                             <div className='plan-detail-icon'>
                               <FontAwesomeIcon icon={faCalendarAlt} />
                             </div>
                             <div className='plan-detail-content'>
                               <span className='plan-detail-label'>Data de start</span>
                               <span className='plan-detail-value'>01/12/2024</span>
                             </div>
                           </div>
                           
                           <div className='plan-detail-item'>
                             <div className='plan-detail-icon'>
                               <FontAwesomeIcon icon={faCalendarCheck} />
                             </div>
                             <div className='plan-detail-content'>
                               <span className='plan-detail-label'>Valabil pana la</span>
                               <span className='plan-detail-value'>01/12/2025</span>
                             </div>
                           </div>
                           
                           <div className='plan-detail-item'>
                             <div className='plan-detail-icon'>
                               <FontAwesomeIcon icon={faCalendar} />
                             </div>
                             <div className='plan-detail-content'>
                               <span className='plan-detail-label'>Urmatoarea facturare</span>
                               <span className='plan-detail-value'>02/12/2024</span>
                             </div>
                           </div>
                           
                           <div className='plan-detail-item'>
                             <div className='plan-detail-icon'>
                               <FontAwesomeIcon icon={faCreditCard} />
                             </div>
                             <div className='plan-detail-content'>
                               <span className='plan-detail-label'>Metoda de plata</span>
                               <span className='plan-detail-value'>Card •••• 1234</span>
                             </div>
                           </div>
                         </div>
                         
                         <div className='plan-card-footer'>
                           <button className='btn-download-invoice'>
                             <FontAwesomeIcon icon={faFileInvoice} style={{ marginRight: '8px' }} />
                             Descarca factura
                           </button>
                           <button className='btn-manage-subscription'>
                             <FontAwesomeIcon icon={faCog} style={{ marginRight: '8px' }} />
                             Gestioneaza abonament
                           </button>
                         </div>
                       </div>


                        
                       
                    </div>
                    
                </div>);
                }
                else if (pageDashbord === 'deleteAccount') {
                    // Functia pentru a inchide contul utilizatorului
                    const handleDeleteAccount = async () => {
                      if (window.confirm('Esti sigur ca doresti sa iti inchizi contul? Aceasta actiune este ireversibila.')) {
                        try {
                          const response = await fetch(`${process.env.REACT_APP_API_URL}/delete-account`, {
                            method: 'DELETE',
                            credentials: 'include'
                          });
                  
                          if (response.ok) {
                            alert('Contul tau a fost sters cu succes.');
                            window.location.href = '/'; // Redirectioneaza la pagina de start dupa stergere
                          } else {
                            alert('A aparut o problema la stergerea contului. Te rugam sa incerci din nou.');
                          }
                        } catch (error) {
                          console.error('Eroare la stergerea contului:', error);
                          alert('A aparut o eroare. Te rugam sa incerci din nou mai tarziu.');
                        }
                      }
                    }

          
                  
                    return (
                      <div className='container-mob-menu-width'>
                        <div className='sub-arrow-info' onClick={funcShowCloseAccount}>
                          <div className='arrow-submenu-user-items'>
                            <FontAwesomeIcon icon={faChevronLeft} className='size-arrow-mob-user' />
                          </div>
                          <div className='button-exit-setari'>Gata</div>
                          
                        </div>
                        <div className='width-submenu-elements'>
                          <h4 className='title-setari-info'>Inchidere cont</h4>
                          
                          {/* Card de avertizare */}
                          <div className='delete-account-container'>
                            <div className='delete-warning-card'>
                              <div className='warning-icon-wrapper'>
                                <FontAwesomeIcon icon={faTrash} className='warning-icon-large' />
                              </div>
                              <h5 className='warning-title'>Atentie! Aceasta actiune este ireversibila</h5>
                              <p className='warning-description'>
                                Inchiderea contului tau va avea urmatoarele consecinte:
                              </p>
                              
                              <div className='consequences-list'>
                                <div className='consequence-item'>
                                  <div className='consequence-icon danger'>
                                    <FontAwesomeIcon icon={faTrash} />
                                  </div>
                                  <div className='consequence-text'>
                                    <strong>Stergerea permanenta</strong>
                                    <span>Toate datele tale vor fi sterse definitiv</span>
                                  </div>
                                </div>
                                
                                <div className='consequence-item'>
                                  <div className='consequence-icon danger'>
                                    <FontAwesomeIcon icon={faTrash} />
                                  </div>
                                  <div className='consequence-text'>
                                    <strong>Pierderea accesului</strong>
                                    <span>Nu vei mai putea accesa contul sau progresul tau</span>
                                  </div>
                                </div>
                                
                                <div className='consequence-item'>
                                  <div className='consequence-icon danger'>
                                    <FontAwesomeIcon icon={faTrash} />
                                  </div>
                                  <div className='consequence-text'>
                                    <strong>Anularea abonamentului</strong>
                                    <span>Abonamentul tau va fi anulat imediat</span>
                                  </div>
                                </div>
                              </div>
                              
                              <div className='delete-actions'>
                                <button onClick={funcShowCloseAccount} className='btn-cancel-delete'>
                                  <FontAwesomeIcon icon={faChevronLeft} style={{ marginRight: '8px' }} />
                                  Renunta
                                </button>
                                <button onClick={handleDeleteAccount} className='btn-confirm-delete'>
                                  <FontAwesomeIcon icon={faTrash} style={{ marginRight: '8px' }} />
                                  Inchide contul permanent
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  }
                  else if (pageDashbord === 'preferences') {
  return (
    <div className='container-mob-menu-width'>
      <div className='sub-arrow-info'>
        <div className='arrow-submenu-user-items'>
          <FontAwesomeIcon icon={faChevronLeft} className='size-arrow-mob-user' onClick={funcShowInfoPersMob} />
        </div>
        <div className='button-exit-setari'>Gata</div>
       
      </div>

      <div className='width-submenu-elements'>
        <h4 className='title-setari-info'>Preferinte</h4>
        
        {/* Secțiune Dark Mode modernă */}
        <div className='preferences-container'>
          
          <div className='preference-card'>
            <div className='preference-header'>
              <div className='preference-icon-wrapper dark-mode-icon'>
                🌙
              </div>
              <div className='preference-info'>
                <h5 className='preference-title'>Mod intunecat</h5>
                <p className='preference-description'>
                  Activeaza tema intunecata pentru a reduce oboseala ochilor
                </p>
              </div>
            </div>
            <label className="toggle-switch">
              <input 
                type="checkbox" 
                checked={darkMode}
                onChange={handleDarkModeToggle}
              />
              <span className="toggle-slider"></span>
            </label>
          </div>

          <div className='preference-card'>
            <div className='preference-header'>
              <div className='preference-icon-wrapper sound-icon'>
                🎵
              </div>
              <div className='preference-info'>
                <h5 className='preference-title'>Efecte sonore</h5>
                <p className='preference-description'>
                  Reda sunete pentru notificari si actiuni
                </p>
              </div>
            </div>
            <label className="toggle-switch">
              <input 
                type="checkbox" 
                checked={soundEffects}
                onChange={handleSoundEffectsToggle}
              />
              <span className="toggle-slider"></span>
            </label>
          </div>

        </div>

      </div>
    </div>
  );
}

                  
        else {
                return (
                <div className='container-mob-menu-width'>
                    <div className='sub-arrow-info' onClick={funcShowInfoPersMob}>
                        <div className='arrow-submenu-user-items'><FontAwesomeIcon icon={faChevronLeft} className='size-arrow-mob-user' /></div>
                        <div className='button-exit-setari'>Gata</div>
                    </div>
                    
                    <div className='width-submenu-elements'>
                       <h4 className='title-setari-info'>Profil</h4>
                       
                        {/* Sectiunea pentru poza de profil - imbunatatita */}
                        <div className='profile-picture-section'>
                            <div className='profile-picture-wrapper'>
                                <div className='profile-picture-container'>
                                    <img
                                      src={previewImage || userData.profile_picture || 'https://via.placeholder.com/150'}
                                      alt='Profile'
                                      className='profile-picture-img'
                                    />
                                    {previewImage && (
                                        <div className='preview-badge'>Preview</div>
                                    )}
                                </div>
                                
                                <div className='profile-picture-info'>
                                    <h5 className='profile-picture-title'>Fotografie de profil</h5>
                                    <p className='profile-picture-description'>
                                      JPG, PNG sau GIF. Dimensiune maxima 5MB.<br/>
                                      Imaginea va fi redimensionata automat la 400x400px.
                                    </p>
                                    
                                    <div className='profile-picture-actions'>
                                        {/* Buton pentru incarcare */}
                                        <label className='btn-upload-new'>
                                            <FontAwesomeIcon icon={faCheck} style={{ marginRight: '8px' }} />
                                            {selectedFile ? 'Schimba imaginea' : 'Incarca imagine'}
                                            <input type='file' accept='image/*' onChange={handleFileChange} style={{ display: 'none' }} />
                                        </label>

                                        {/* Buton pentru setare imagine */}
                                        {selectedFile && (
                                            <button className='btn-save-picture' onClick={uploadProfilePicture}>
                                                <FontAwesomeIcon icon={faCheck} style={{ marginRight: '8px' }} />
                                                Salveaza
                                            </button>
                                        )}

                                        {/* Buton pentru stergere */}
                                        {userData.profile_picture && (
                                            <button className='btn-delete-picture' onClick={handleDeleteProfilePicture}>
                                                <FontAwesomeIcon icon={faTrash} style={{ marginRight: '8px' }} />
                                                Sterge
                                            </button>
                                        )}
                                    </div>
                                    
                                    {/* Mesaj de succes */}
                                    {successMessage && (
                                        <div className='alert-success'>
                                            <FontAwesomeIcon icon={faCheck} style={{ marginRight: '8px' }} />
                                            {successMessage}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                      
                        {/* Formular pentru informatii personale - imbunatatit */}
                        <form className='profile-form'>
                            <div className='form-group-modern'>
                                <label className='form-label-modern'>Nume utilizator</label>
                                <input 
                                    type='text' 
                                    className='form-input-modern' 
                                    value={userData.username}
                                    placeholder='Introdu numele tau'
                                />
                            </div>
                            
                            <div className='form-group-modern'>
                                <label className='form-label-modern'>Adresa de email</label>
                                <input 
                                    type='email' 
                                    className='form-input-modern' 
                                    value={userData.email}
                                    placeholder='email@example.com'
                                    disabled
                                />
                                    <small className='form-hint'>Email-ul nu poate fi modificat</small>
                            </div>
                            
                            <button type='submit' className='btn-save-profile'>
                                <FontAwesomeIcon icon={faCheck} style={{ marginRight: '8px' }} />
                                Salveaza modificarile
                            </button>
                        </form>
                    </div>

                </div>
            );
        }
        
           
    }

 

    const closePage = () => {
  if (window.history.length > 1) {
    navigate(-1);
  } else {
    navigate("/userpage"); // fallback dacă nu există istoric
  }
};

  return (

    <div className='height-page-setari'>

      {/* Header cu logo si X */}
             <div className="header-prem-top-s">
              <div className="header-premium-s">
                <div className="logo-dist-premium-s">
                  <img src={Logo} alt="logo-premium" className="logo-premuim" />
                </div>
                <div className="x-dist-premium" onClick={closePage}>
                  <div className="exit-premium-vp">Inapoi</div>
                </div>
              </div>
            </div>
            <div className='line-view-plans-menu'></div>

    <div className='settings-section'>


     



        <div className='settings-dashbord'>
            <div className='button-exit-change-menu-profile'>
                <div className='arrow-submenu-user-items' onClick={() => redirectToDashbord('/userpage')}><FontAwesomeIcon icon={faChevronLeft} className='size-arrow-mob-user' /></div>
                <div className='button-exit-setari'>Gata</div>

            </div>
            <div className='buttons-menu-settings'>

              <div className='button-edit-user-profile-desktop-show-title'>Setari</div>
               <h4 className='main-title-setari'>Setari</h4>

                <div className='button-edit-user-profile-mob' onClick={() => {setPageDashbord('true'); setShowInfoPersMob('0')}}>
                    
                    <div
                      className={`button-edit-user-profile-desktop-show ${activeMenu === 'personalInfo' ? 'active' : ''}`}
                      onClick={() => setActiveMenu('personalInfo')}
                    >
                      Profil
                    </div>
                    
                    <h5 className='button-edit-user-profile-desktop-hide'>Profil</h5>

                    <div className='arrow-submenu-user-items'><FontAwesomeIcon icon={faChevronRight} className='size-arrow-mob-user' /></div>
                </div>
                <div className='line-setari-menu-mob'></div>
                <div
                  className='button-edit-user-profile-mob'
                  onClick={() => {
                    setPageDashbord('preferences');
                    setShowInfoPersMob('0');
                  }}
                >
                  <div
                    className={`button-edit-user-profile-desktop-show ${activeMenu === 'preferences' ? 'active' : ''}`}
                    onClick={() => setActiveMenu('preferences')}
                  >
                    Preferinte
                  </div>
                  <h5 className='button-edit-user-profile-desktop-hide'>Preferinte</h5>
                  <div className='arrow-submenu-user-items'>
                    <FontAwesomeIcon icon={faChevronRight} className='size-arrow-mob-user' />
                  </div>
                </div>
                <div className='line-setari-menu-mob'></div>
                <div className='button-edit-user-profile-mob' onClick={() => {setPageDashbord('changePass'); setShowInfoPersMob('0')}}>
                    <div
                      className={`button-edit-user-profile-desktop-show ${activeMenu === 'changePass' ? 'active' : ''}`}
                      onClick={() => setActiveMenu('changePass')}
                    >
                      Schimbare parola
                    </div>
                    <h5 className='button-edit-user-profile-desktop-hide'>Schimbare parola</h5>
                    <div className='arrow-submenu-user-items'><FontAwesomeIcon icon={faChevronRight} className='size-arrow-mob-user' /></div>
                </div>
                <div className='line-setari-menu-mob'></div>
                <div className='button-edit-user-profile-mob' onClick={() => {setPageDashbord('infoFact'); setShowInfoPersMob('0')}}>
                    <div
                      className={`button-edit-user-profile-desktop-show ${activeMenu === 'infoFact' ? 'active' : ''}`}
                      onClick={() => setActiveMenu('infoFact')}
                    >
                      Detalii plan
                    </div>
                    <h5 className='button-edit-user-profile-desktop-hide'>Detalii plan</h5>
                    <div className='arrow-submenu-user-items'><FontAwesomeIcon icon={faChevronRight} className='size-arrow-mob-user' /></div>
                </div>
                <div className='line-setari-menu-mob'></div>
                <div className='button-edit-user-profile-mob' onClick={() => {setPageDashbord('deleteAccount'); setShowInfoPersMob('0')}}>
                    <div
                      className={`button-edit-user-profile-desktop-show ${activeMenu === 'deleteAccount' ? 'active' : ''}`}
                      onClick={() => setActiveMenu('deleteAccount')}
                    >
                      Inchidere cont
                    </div>
                    <h5 className='button-edit-user-profile-desktop-hide'>Inchidere cont</h5>
                    <div className='arrow-submenu-user-items'><FontAwesomeIcon icon={faChevronRight} className='size-arrow-mob-user' /></div>
                </div>
                



             



            </div>

<div className='background-plan-asistance'>
 <div className='abonament-setari'>
  <div className='title-second-setari'>Planul tau</div>
  <Link to='/planul-tau' className='link-setari-none'>
    <div className='plan-card-setari'>
      <div className='plan-card-header-small'>
        <div className='plan-icon-wrapper'>
          <FontAwesomeIcon icon={faCrown} className='plan-icon-small' />
        </div>
        <div className='plan-info-small'>
          <h5>Plan PERSONAL</h5>
          <span>Activ • 49.99 RON/luna</span>
        </div>
      </div>
      <div className='plan-card-footer-small'>
        <span>Vezi detalii si gestioneaza</span>
        <FontAwesomeIcon icon={faChevronRight} />
      </div>
    </div>
  </Link>
  </div>
 
  <div className='asistenta-setari'>
    <div className='title-second-setari'>Asistenta</div>
    <Link to='/FAQ' className='link-setari-none'>
    <div className='help-center-setari'>Centru de ajutor</div>
    </Link>
    <Link to='/feedback' className='link-setari-none'>
    <div className='help-center-setari'>Feedback</div>
    </Link>
  </div>


 

        <div className='disconect-button'>
          <p>Deconectare</p>
        </div>
       

                </div>



        </div>
        <div className='details-settings' style={{zIndex: showInfoPersMob}} id='set-important-submenu'>
            {renderpageDashbord()}
        </div>

        <div className='details-settings' id='set-important-submenu-second'>
            {renderpageDashbord()}
        </div>
        
        
    </div>
    </div>
  )
}

export default Setari;